import { Toaster } from "sonner";

/* LAYOUT */
import Header from "./header";
import Footer from "./footer";

const Layout = ({ children }) => {
  return (
    <div className="p-0">
      <Toaster position="top-right" expand={false} duration={3000} richColors />

      {/* HEADER */}
      <Header />

      {/* CHILDREN */}
      <div className="h-[83vh] overflow-auto hide-scrollbar">{children}</div>

      {/* FOOTER */}
      <Footer />
    </div>
  );
};

export default Layout;
